// src/utils/device.ts
export type DevicePlatform = "unknown" | "apple" | "android" | "windows" | "linux";


export function detectDevicePlatform(userAgent: string): DevicePlatform {
    if (/android/i.test(userAgent)) {
      return "android";
    } else if (/iphone|ipad|ipod|mac|macintosh/i.test(userAgent)) {
      return "apple";
    } else if (/windows/i.test(userAgent)) {
      return "windows";
    } else if (/linux/i.test(userAgent)) {
      return "linux";
    } else {
      return "unknown";
    }
}


import { useEffect, useState } from "react";

export function useDevicePlatform() {
  const [userAgent, setUserAgent] = useState<string>(navigator.userAgent);
  const [platform, setPlatform] = useState<DevicePlatform>(detectDevicePlatform(navigator.userAgent));

  useEffect(() => {
    const handleUserAgentChange = () => {
      const newUserAgent = navigator.userAgent;
      setUserAgent(newUserAgent);
      setPlatform(detectDevicePlatform(newUserAgent));
    };
    window.addEventListener("useragentchange", handleUserAgentChange);
    return () => {
      window.removeEventListener("useragentchange", handleUserAgentChange);
    };
  }, []);

  return { userAgent, platform };
}
